import { spinner } from '../spinner/spinner';

import SelectInput from '../selectInput/selectInput';

import './less/basicContactForm.less';

const BasicContactForm = function(){
    let _this = this;
    let form = $('#contact-form');
    this.id = 'contactEnquiry';
    $('.zero').val(1);
    
    this.validate = () => {
        //console.log('validating');
    };
    
    this.send = form => {
        
        let send =  $.ajax({
            type: 'POST',
            url: form.attr('action') + '&rand=' + Math.random(),
            data: form.serialize()
        });
        
        send.done(response => {
            let data = $.parseJSON(response);
            spinner.remove();
            
            $('.form-info').empty().append(data.contents).addClass(data.status);
            
            if (data.status === 'ok') {
                form.find("input[type='text'], input[type='email'], textarea").val('');
                
                //Set default phone value: UNUSED
                form.find('[data-default]').each(function () {
                    form.val(form.data('default'));
                });
                
            } else {
                if (data.fields !== undefined) {
                    for (let i = 0; i <= (data.fields).length; i++) {
                        form.find(".formField" + data.fields[i]).addClass('error');
                    }
                }
            }
        });
        
    };
    
    form.submit(function (e) {
        e.preventDefault();
        spinner.show(form, '#ffffff');
        $('input, textarea').removeClass('error').removeClass('ok');
        _this.send(form);
    });
    
    
    /*	this.handleSubmit = () => {
            $('.contactFormular__button').click((e) => {
                e.preventDefault();
                //_this.validate();
                _this.send();
            });
        };*/
    
    /*this.handleSubmit();*/
    
};


export { BasicContactForm};


// WEBPACK FOOTER //
// ./components/basicContactForm/basicContactForm.js